<div class="row">

	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="card-datatable"
			[options]="false">

			<a
				class="float-right btn btn-sm btn-primary"
				(click)="add()">
				<i
					container="body"
					ngbTooltip="{{'labels.add-tool' | translate}}"
					class="feather icon-plus"></i>
			</a>

			<div class="table-responsive">

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="rows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="true"
					[externalSorting]="true"
					[loadingIndicator]="loading"
					[count]="page.totalElements"
					[offset]="page.pageNumber"
					[limit]="page.size"
					(page)="onPageChange($event)"
					(sort)="onSortChange($event)"
					[messages]="{
          emptyMessage: 'labels.empty-tools' | translate,
          totalMessage: 'labels.total' | translate
		}">
					<!-- ID -->
					<ngx-datatable-column
						[flexGrow]="0.5"
						[name]="'labels.id' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{row.tool.id}}
						</ng-template>
					</ngx-datatable-column>

					<!-- NOME -->
					<ngx-datatable-column
						[flexGrow]="2"
						[name]="'labels.name' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a
								class="link"
								routerLink="/company/tool/view/{{row.tool.id}}"
								ngbTooltip="{{'labels.tool-details' | translate}}">
								{{row.tool.name}}
							</a>
						</ng-template>
					</ngx-datatable-column>

					<!-- AZIENDA -->
					<ngx-datatable-column
						[flexGrow]="2"
						[name]="'labels.company' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>

							<a
								routerLink="/company/view/{{row.tool.company.id}}"
								class="link"
								ngbTooltip="{{'labels.company-details' | translate}}">
								{{row.tool.company.name}}
							</a>
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">

								<a
									(click)="delete(row)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.delete' | translate}}"
										class="feather icon-trash"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</app-card>
	</div>
</div>
